import _get from 'lodash/get'
import { getPermissions } from '../_theme/utils'
import { getConfig } from '../utils/configUtils'
import { PATHS } from '../constants/paths'
import { ROLES } from '../constants/roles'

export const detectPermissionIsDenied = ({ event, user, path }) => {
  const externalEventPartner = event?.externalEventPartner
  const role = event?.self.role
  const permissions = getPermissions(role)
  const isAdminOrOwner = permissions.isAdminOrOwner()
  const configFile = getConfig()
  const domain = _get(configFile, '*.domain')
  const userIsTFStaff = user && user.tfStaff
  const domains = _get(configFile, 'global.CONSTANTS.DOMAINS', [])
  let isAllowed = false

  for (const allowedDomain of domains) {
    if (allowedDomain === externalEventPartner) {
      isAllowed = true
    }
  }
  const isPermissionDenied =
    (externalEventPartner && !(externalEventPartner === domain || isAllowed)) ||
    (event && ROLES.is_support_or_partial_support(role) && !PATHS.isIncludePaths(path, [103])) ||
    (role && !isAdminOrOwner && PATHS.isEditLevelPath(path)) ||
    (!role && !userIsTFStaff) ||
    (PATHS.isIncludePaths(path, [303]) && !ROLES.is_tf_support(user.tfRole))

  return isPermissionDenied
}
